import { staticResource } from '@/lib/shared/utils/resources';
import { sendSocialClick } from '@/lib/shared/utils/send-gtm';

import { clsx } from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import styles from '../Card.module.scss';

interface IProps {
  image: string;
  path: string;
}

export const InstagramCard = ({ image, path }: IProps) => {
  const href =
    path.startsWith('http://') || path.startsWith('https://')
      ? path
      : `https://www.instagram.com/p/${path}`;

  return (
    <Link
      aria-label="instagram post"
      target={'_blank'}
      href={href}
      onClick={sendSocialClick}
    >
      <div className={clsx(styles.card, styles['card--insta'])}>
        <Image
          sizes="(max-width: 1624px): 255px, (max-width: 996px) 211px, 211px"
          src={staticResource(image)}
          alt={''}
          fill
        />
      </div>
    </Link>
  );
};

export default InstagramCard;
